import { Source, Layer } from 'react-map-gl';
import { COLOR } from '../styles';
import { sourceProps } from './source-utils';

export type AoiLayerProps = {
  url: string;
  /** Mapbox source id (default `aoi`). */
  sourceId?: string;
  fillLayerId?: string;
  outlineLayerId?: string;
  /** Si `false`, no dibuja el contorno aquí (útil para pintarlo encima de parcelas más adelante). */
  showOutline?: boolean;
  /** Override del relleno (default lima AOI). */
  fillColor?: string;
  fillOpacity?: number;
};

export function AoiLayer({
  url,
  sourceId = 'aoi',
  fillLayerId = 'aoi-fill',
  outlineLayerId = 'aoi-outline',
  showOutline = true,
  fillColor = COLOR.lime,
  fillOpacity = 0.04,
}: AoiLayerProps) {
  return (
    <Source id={sourceId} {...sourceProps(url)}>
      <Layer
        id={fillLayerId}
        type="fill"
        // Fill muy tenue para no tapar las parcelas que estan dentro del AOI.
        paint={{ 'fill-color': fillColor, 'fill-opacity': fillOpacity }}
      />
      {showOutline && (
        <Layer
          id={outlineLayerId}
          type="line"
          // Borde grueso y vivo: el AOI se identifica por su contorno, no por el fill.
          paint={{ 'line-color': fillColor, 'line-width': 2.4 }}
        />
      )}
    </Source>
  );
}
